const LINKEDIN_URL = 'https://www.linkedin.com/in/vinoth-trevor-skanthavarathan-01b6ba141/';

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="px-6 md:px-12 py-8 flex flex-col md:flex-row items-center justify-between gap-4"
      style={{ backgroundColor: '#353840', borderTop: '1px solid rgba(255,255,255,0.04)' }}
    >
      <span className="text-muted text-sm" data-testid="footer-copyright">
        &copy; 2026 Soundboard.space
      </span>
      <span
        className="text-sm italic"
        style={{ color: 'rgba(255,255,255,0.30)', fontFamily: "var(--font-body)" }}
        data-testid="footer-tagline"
      >
        Before it costs you.
      </span>
      <a
        href={LINKEDIN_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="coral-link text-sm"
        data-testid="footer-linkedin"
      >
        Connect on LinkedIn &rarr;
      </a>
    </footer>
  );
};

export default Footer;
